interface SparklineProps {
  data: number[];
  width?: number;
  height?: number;
  declining?: boolean;
}

export function Sparkline({ data, width = 120, height = 24, declining = false }: SparklineProps) {
  if (data.length < 2) return null;

  const color = declining ? 'var(--err)' : 'var(--accent)';
  const max = Math.max(...data, 1);
  const min = Math.min(...data, 0);
  const range = max - min || 1;

  // Build points
  const points = data.map((v, i) => {
    const x = (i / (data.length - 1)) * width;
    const y = height - ((v - min) / range) * (height - 2) - 1;
    return `${x},${y}`;
  });

  // Build area path (closed polygon for gradient fill)
  const areaPath = `M0,${height} L${points.map(p => p).join(' L')} L${width},${height} Z`;

  const gradientId = `spark-grad-${declining ? 'err' : 'ok'}-${Math.random().toString(36).slice(2, 6)}`;

  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} style={{ display: 'block', width: '100%', maxWidth: width }}>
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0.25" />
          <stop offset="100%" stopColor={color} stopOpacity="0.02" />
        </linearGradient>
      </defs>
      <path d={areaPath} fill={`url(#${gradientId})`} />
      <polyline
        points={points.join(' ')}
        fill="none"
        stroke={color}
        strokeWidth="1.5"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  );
}
